export const USER_LIST = 'userList';

export const HAS_EXTERNAL = 'hasExternal';

export const ENTITIES = 'entities';
export const ACCESS_TO_DASHBOARD = 'accessToDashboard';
export const DASHBOARD_VIEWS = 'dashboardViews';
export const ACCESS_TO_CONTACT_LIST = 'accessToContactList';
export const ACCESS_TO_GROUP_RISK_ASSESMENT = 'accessToGroupRiskAssessment';
